import React, { useState, useEffect } from "react";
import { Loader, Image } from "semantic-ui-react";
import { size } from "lodash";
import { UserPartner } from "../../../../../api";
import { useAuth } from "../../../../../hooks";
import "./PartnerProfile.scss";

const userPartnerController = new UserPartner();

export function PartnerProfile(props) {
  const { user, accessToken } = useAuth();
  const { reload } = props;
  const [partner, setPartner] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        //console.log("user.user", user.user);
        if (user?.user?.holded) {
          const response = await userPartnerController.getPartner(
            accessToken,
            user.user.holded,
          );
          //console.log("response", response.contact);
          setPartner(response);
        }
      } catch (error) {
        console.error("Error al obtener el partner:", error);
      }
    })();
  }, [reload, user, accessToken]);

  if (!partner) return <Loader active inline="centered" />;
  if (size(partner) === 0) return <h2>No hay datos del partner</h2>;

  return (
    <div className="partner-profile">
      {user.user?.avatar && (
        <Image src={user.user.avatar} alt="Avatar del Partner" circular />
      )}

      <div className="partner-details">
        {partner && (
          <div className="holded-details">
            <h3>Profile Partner</h3>
            <p>Cliente: {partner.contact.name || "No disponible"}</p>
            <p>Cif: {partner.contact.code || "No disponible"}</p>
            <p>
              Web: {partner.contact.socialNetworks.website || "No disponible"}
            </p>
          </div>
        )}
        <p></p>
        <p>
          {user.user?.firstname + " " + user.user?.lastname ||
            "Nombre no disponible"}
        </p>
        <p>Email: {user.user?.email || "Email no disponible"}</p>
        {user.user?.phone && <p>Teléfono: {user.user.phone}</p>}
      </div>
    </div>
  );
}
